import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import {withMemo} from 'helpers/wrapper';
import {Span} from 'components/atoms/Text/Typography/Typography';
import Link from 'components/atoms/Links/Link/Link';
import InputAdornment from 'components/atoms/Inputs/InputAdornment/InputAdornment';
import Icon from 'components/atoms/Icons/Icon/Icon';
import StyledLinkField from 'components/molecules/Fields/LinkField/LinkField.styles';
import {default as LinkIcon} from '@mui/icons-material/Link';

const LinkField = withMemo(React.forwardRef((props, ref) => {
  const {
    target,
    showLinkIcon,
    ...innerProps
  } = useComponentProps(props, 'LinkField', {
    static: ['showLinkIcon']
  });

  const renderReadOnly = (value, props) => {
    if (value) {
      if (showLinkIcon) {
        return <React.Fragment>
          <InputAdornment size={innerProps?.size ?? 'small'}
                          position="start">
            <Link href={utils.cleanExternalLink(value)} target={target ?? '_blank'}
                  onClick={(e) => e.stopPropagation()}>
              <Icon icon={LinkIcon} size="small"/>
            </Link>
          </InputAdornment>
          <Span showTooltip={props.showTooltip}>
            {utils.displayExternalLink(value)}
          </Span>
        </React.Fragment>;
      } else {
        return <Span showTooltip={props.showTooltip}>
          <Link href={utils.cleanExternalLink(value)} target={target ?? '_blank'}
                onClick={(e) => e.stopPropagation()}>
            {utils.displayExternalLink(value)}
          </Link>
        </Span>
      }
    } else {
      return (props.placeholder && !props.hiddenPlaceholder) ?
        <Span className="placeholder" showTooltip={props.showTooltip}>{props.placeholder}</Span> :
        <Span>&nbsp;</Span>;
    }
  }

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledLinkField ref={ref} {...innerProps} renderReadOnly={renderReadOnly}/>
}));

LinkField.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  showLinkIcon: PropTypes.bool
};

export default LinkField;
